import { render, staticRenderFns } from "./ProductAvailabilityView.vue?vue&type=template&id=1a573702&"
import script from "./ProductAvailabilityView.vue?vue&type=script&lang=js&"
export * from "./ProductAvailabilityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports